export default __webpack_public_path__ + "050578ba2550e75d147a4a17b1f91f4b.png";